module.exports = __webpack_public_path__ + "img/Group 198.2c073012.svg";